import { Modal } from '@mui/material';
import React from 'react';
import t from "../components/I18N/TranslateHelpers";

interface ConfirmModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  onCancel,
  onConfirm,
  title,
  message,
  confirmLabel = 'confirm',
  cancelLabel = 'cancel',
}) => {

  return (
    <Modal open={isOpen}>
      <div className="card modal-dialog">
        <div className="modal-header">
          <h5 className="modal-title">{t(title)}</h5>
          <button type="button" className="close" onClick={onCancel}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <p>{t(message)}</p>
          <div className="d-flex">
            <button className="btn btn-primary mr-3" onClick={onCancel}>
              {t(cancelLabel)}
            </button>
            <button className="btn btn-primary-outline" onClick={onConfirm}>
              {t(confirmLabel)}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
